module.exports = __webpack_public_path__ + "img/canada-cardiovascular-diseases-male.b05baf19.png";